import * as React from "react";
import * as _ from "lodash";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { ScheduleCalendar } from "src/core/schedules/components/ScheduleCalendar";
import { IList } from "src/core/lists/api/lists.api";
import { ISchedule } from "src/core/schedules/api/schedules.api";
import { IDrop } from "src/core/drops/api/drops.api";
import { IOrderStatus } from "src/core/orders/api/orders.api";
import {
  IError,
  IListErrorData
} from "src/core/errors/api/errors.api";

import ScheduleDetailFormInfo from "./ScheduleDetailFormInfo";

interface IScheduleFormProps {
  data: IList | null;
  schedule: ISchedule | null;
  drop: IDrop;
  terminology: ITerminology;
  scheduleErrors?: Array<IError<IListErrorData>>;
  orderStatuses: IOrderStatus[];
  setScheduleViewSetting: (type: "detail" | "edit") => void,
  handleSuspendSchedule: (id: number) => void;
  handleReactivateSchedule: (id: number) => void;
  isScheduleLoading: boolean;
  isLoading: boolean;
}

const ScheduleDetailForm: React.ReactFCWithChildren<IScheduleFormProps> = ({
  schedule,
  terminology,
  data,
  drop,
  setScheduleViewSetting,
  scheduleErrors,
  orderStatuses,
  handleSuspendSchedule,
  handleReactivateSchedule,
  isScheduleLoading,
  isLoading
}) => {
  return (
    <Container className={schedule && schedule.status === "suspended" ? "suspended" : "enabled"}>
      {schedule && schedule.validating ? (
        <Group>
          <Text>
            {`Validating ${terminology.schedule.plural.text}...`}
          </Text>
        </Group>
      ) : (
        <>
          <Group>
            <ScheduleDetailFormInfo
              schedule={schedule}
              terminology={terminology}
              list={data}
              drop={drop}
              setScheduleViewSetting={setScheduleViewSetting}
              orderStatuses={orderStatuses}
              isScheduleLoading={isScheduleLoading}
              isLoading={isLoading}
              handleSuspendSchedule={handleSuspendSchedule}
              handleReactivateSchedule={handleReactivateSchedule}
            />
          </Group>

          <Group className="schedule-calendar">
            <ScheduleCalendar
              orderStatuses={orderStatuses}
              terminology={terminology}
              scheduleErrors={scheduleErrors}
              schedule={schedule}
              drop={drop}
            />
          </Group>
        </>
      )}
    </Container>
  );
};

const FormLine = styled.div`
  display: flex;
  align-items: left;
  flex-direction: column;
  ${({ theme }) => css`
    padding: ${theme.spacing.padding.md} 0;
  `}
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  &.suspended ${FormLine} {
    opacity: 0.5;
    pointer-events: none;
  }
`;

const Group = styled.div`
  ${({ theme }) => css`
    flex-grow: 1;
    width:50%;
    padding: 0 ${theme.spacing.padding.sm};

    &.schedule-calendar {
      min-width: 300px;
    }
    &:first-child {
      border-right: 1px solid ${theme.colors.lightGrey};
    }
  `}
`;

export default ScheduleDetailForm;
